let func = () => {};

if (process.env.VUE_APP_TRACKING_MODE === 'on') {
    func = () => {
        let script = document.createElement('script');
        script.id = 'hs-script-loader';
        script.src = '//js.hs-scripts.com/20879441.js';
        document.body.append(script);
    };
}

func();
